import {useRouterHistory} from 'react-router';
import {createHashHistory} from 'history';

// eslint-disable-next-line react-hooks/rules-of-hooks
const History = useRouterHistory(createHashHistory)({queryKey: false});

export default History;
